import { apiClient } from './client';
import type { CartResponse, CheckoutResponse } from '../types';

export const cartApi = {
  // Get cart
  getCart: () => apiClient.get<CartResponse>('/cart'),

  // Add item to cart
  addItem: (productId: number, quantity: number) =>
    apiClient.post<{ message: string }>('/cart/items', {
      product_id: productId,
      quantity,
    }),

  // Update cart item quantity
  updateItem: (itemId: number, quantity: number) =>
    apiClient.put<{ message: string }>(`/cart/items/${itemId}`, { quantity }),

  // Remove item from cart
  removeItem: (itemId: number) =>
    apiClient.delete<{ message: string }>(`/cart/items/${itemId}`),

  // Checkout
  checkout: (deliveryAddressId: number, paymentMethod: string, notes?: string) =>
    apiClient.post<CheckoutResponse>('/cart/checkout', {
      delivery_address_id: deliveryAddressId,
      payment_method: paymentMethod,
      notes,
    }),
};
